<template>
    <div>

        <div class="conteudo backg-logado">
            <v-app-bar app height="96" absolute hide-on-scroll class="xs-100">
                <div class="btn-group d-flex align-items-center justify-content-between">
                    <v-app-bar-nav-icon @click.stop="drawer = !drawer"
                        class="hidden-md-and-up branco"></v-app-bar-nav-icon>
                    <v-img alt="Editora do Brasil" class="shrink" contain src="@/assets/logo-white.png"
                        transition="scale-transition" width="120" />
                    <v-toolbar-title class="txt-titulo hidden-md-and-up">
                        <h2>Consultor<br>Digital</h2>
                    </v-toolbar-title>
                    <v-toolbar-title class="txt-titulo hidden-sm-and-down">
                        <h2>Consultor Digital</h2>
                    </v-toolbar-title>
                </div>

                <v-row class="busca">
                    <v-col cols="12">
                        <div class="d-flex justify-center">
                            <div class="campo-de-busca">
                                <div class="autosuggest-container">
                                    <vue-autosuggest v-model="query" :suggestions="filteredOptions" @focus="focusMe"
                                        @input="onInputChange" @selected="onSelected"
                                        :get-suggestion-value="getSuggestionValue"
                                        :input-props="{ id: 'autosuggest__input', placeholder: 'Digite o nome do livro' }">
                                        <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
                                            <!-- <router-link :to="{name: 'flippingbook', query: { id: suggestion.item.arquivo }}" target="_blank">  </router-link> -->
                                            <img :style="{ display: 'flex', width: 'auto', maxWidth: '28px', height: 'auto', maxHeight: '28px', marginRight: '10px' }"
                                                :src="suggestion.item.imagem" />
                                            <div style="{ display: 'flex', color: 'navyblue'}">{{ suggestion.item.titulo
                                            }}
                                            </div>
                                        </div>
                                    </vue-autosuggest>
                                    <v-btn @click="pesquisarNome()" icon class="mt-1">
                                        <v-icon href color="primary">search</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>

                <v-toolbar-items class="hidden-sm-and-down box-logado">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="primary--text" text v-bind="attrs" v-on="on">
                                <v-img src="@/assets/icon-user.png" /> Olá, <span v-text="userName"></span> <v-icon
                                    right>keyboard_arrow_down</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item>
                                <v-list-item-title>
                                    <v-btn @click="sair()" text block class="primary--text">Sair</v-btn>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-toolbar-items>
            </v-app-bar>
            <v-navigation-drawer class="menu-header-mobile" v-model="drawer" absolute temporary>
                <v-list nav dense>
                    <v-list-item-group active-class="primary--text text--accent-4">
                        <v-list-item two-line :disabled="isMobile">
                            <v-list-item-avatar>
                                <v-icon color="primary">person</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><span v-text="userName"></span></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mb-4"></v-divider>
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon color="primary">mail</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <a class="primary--text" href="//editoradobrasil.com.br/fale-conosco"
                                        target="_blank">Contato</a>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-4 mb-4"></v-divider>

                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon color="primary">logout</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <a class="primary--text" @click="sair()" href="#">Sair</a>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                    </v-list-item-group>
                </v-list>
            </v-navigation-drawer>
        </div>
        <vue-headful title="Catálogo Digital | Editora do Brasil" description="Catálogo Digital da Editora do Brasil" />
        <section>

            <v-container fluid class="pt-8 pb-16 box-conteudo-lag">
                <v-row class="hidden-md-and-up">
                    <v-col cols="12">
                        <v-btn class="btn-filtrar" text @click="sheet = !sheet">
                            <v-icon>filter_list</v-icon>Filtrar
                        </v-btn>
                    </v-col>
                </v-row>

                <v-bottom-sheet v-model="sheet" inset class="hidden-md-and-up">
                    <v-sheet class="text-center" style="overflow-y: auto">
                        <v-card width="100%" outlined class="filtro filtro-mobile">
                            <v-list-item class="title">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Filtros
                                        <v-btn icon class="btn-fechar-filtro" text @click="sheet = !sheet">
                                            <v-icon>close</v-icon>
                                        </v-btn>
                                    </v-list-item-title>
                                    <!-- <v-list-item-subtitle>
                                                        subtext
                                    </v-list-item-subtitle>-->
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item>
                                <v-expansion-panels accordion v-model="panel" :multiple="multiple" :flat="flat">
                                    <!--<v-expansion-panel>
                                                      <v-expansion-panel-header>Lançamentos</v-expansion-panel-header>
                                                      <v-expansion-panel-content>
                                                        <v-row>
                                                          <v-checkbox input-value="true" label="Didático" value></v-checkbox>
                                                        </v-row>
                                                        <v-row>
                                                          <v-checkbox input-value="true" label="Literatura" value></v-checkbox>
                                                        </v-row>
                                                      </v-expansion-panel-content>
                                    </v-expansion-panel>-->
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>Segmento</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row v-for="segmento in segmentos" :key="segmento">
                                                <v-checkbox @change="filterSegmento(segmento)" :label="segmento"
                                                    :value="segmento"></v-checkbox>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>Componente Curricular</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row v-for="disciplina in disciplinas" :key="disciplina">
                                                <v-checkbox @change="filterDisciplina(disciplina)" :label="disciplina"
                                                    :value="disciplina"></v-checkbox>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>Ano</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row v-for="ano in anos" :key="ano">
                                                <v-checkbox @change="filterAno(ano)" :label="ano"
                                                    :value="ano"></v-checkbox>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>Coleção</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row v-for="colecao in colecoes" :key="colecao">
                                                <v-checkbox @change="filterColecao(colecao)" :label="colecao"
                                                    :value="colecao"></v-checkbox>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <!--<v-expansion-panel>
                                                          <v-expansion-panel-header>Autor</v-expansion-panel-header>
                                                          <v-expansion-panel-content>
                                                              <v-row v-for="autor in autores" :key="autor">
                                                                  <v-checkbox @change="filterAutor(autor)" :label="autor" :value="autor"></v-checkbox>
                                                              </v-row>
                                                          </v-expansion-panel-content>
                                    </v-expansion-panel>-->
                                </v-expansion-panels>
                            </v-list-item>
                        </v-card>
                    </v-sheet>
                </v-bottom-sheet>

                <v-card width="280" outlined class="filtro float-left hidden-sm-and-down">
                    <v-list-item class="title">
                        <v-list-item-content>
                            <v-list-item-title>Filtros</v-list-item-title>
                            <!-- <v-list-item-subtitle>
                                                subtext
                            </v-list-item-subtitle>-->
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                        <v-expansion-panels accordion v-model="panel" :multiple="multiple" :flat="flat">
                            <!-- <v-btn @click="limparFiltros()">Limpar Filtros</v-btn> -->
                            <v-expansion-panel>
                                <v-expansion-panel-header>Segmento</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row v-for="segmento in segmentos" :key="segmento">
                                        <v-checkbox @change="filterSegmento(segmento)" :label="segmento"
                                            :value="segmento"></v-checkbox>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Componente Curricular</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row v-for="disciplina in disciplinas" :key="disciplina">
                                        <v-checkbox @change="filterDisciplina(disciplina)" :label="disciplina"
                                            :value="disciplina"></v-checkbox>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Ano</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row v-for="ano in anos" :key="ano">
                                        <v-checkbox @change="filterAno(ano)" :label="ano" :value="ano"></v-checkbox>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Coleção</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row v-for="colecao in colecoes" :key="colecao">
                                        <v-checkbox @change="filterColecao(colecao)" :label="colecao"
                                            :value="colecao"></v-checkbox>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <!--<v-expansion-panel>
                                              <v-expansion-panel-header>Autor</v-expansion-panel-header>
                                              <v-expansion-panel-content>
                                                  <v-row v-for="autor in autores" :key="autor">
                                                      <v-checkbox @change="filterAutor(autor)" :label="autor" :value="autor"></v-checkbox>
                                                  </v-row>
                                              </v-expansion-panel-content>
                            </v-expansion-panel>-->
                        </v-expansion-panels>
                    </v-list-item>
                </v-card>

                <v-row class="grid" align="stretch">
                    <v-container fluid grid-list-md class="pt-0">
                        <v-layout row wrap id="livros-list">
                            <v-flex xs12 sm6 md4 lg4 v-for="card in cards" :key="card.title">

                                <v-hover v-slot:default="{ hover }">
                                    <!--<router-link
                                      :to="{name: 'flippingbook', query: { id: card.arquivo }}"
                                      target="_blank"
                                    >-->
                                    <a>
                                        <v-card height="100%" :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }"
                                            outlined
                                            class="box-con-catalog ml-1 mb-1 ml-sm-4 mb-sm-4 flex v-flex flex-column">
                                            <v-img :src="card.src" height="200px" class="ma-4"></v-img>
                                            <v-card-title v-text="card.title"
                                                @click="abrirFlipbook(card.arquivo, card.isbn, card.complemento)"></v-card-title>

                                            <v-card-actions>
                                                <v-btn large block tile depressed
                                                    @click="abrirFlipbook(card.arquivo, card.isbn, card.complemento)">Visualizar</v-btn>
                                                <v-btn large block tile depressed class="bot-info"
                                                    @click="Visualizacao(card.arquivo, card.isbn, card.complemento)">Informações</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </a>
                                    <!--</router-link>-->
                                </v-hover>
                            </v-flex>
                        </v-layout>
                        <p v-if="cards.length == 0">Não existe um livro com base nos filtros selecionados.</p>
                        <div id="pagination-container" style="display:none;"></div>
                        <!-- modal Error Informações do Livro -->
                        <v-dialog v-model="dialogerror" persistent max-width="360"
                            content-class="box-dialog-inf error-api">
                            <v-btn color="blue darken-1" class="bot-exit" text @click="dialogerror = false">
                                <v-img src="@/assets/iconexit.png" title="Sair" />
                            </v-btn>
                            <v-card>
                                <div class="box-infoerro">
                                    <v-img src="@/assets/icon-triste.png" title="Sem informação" />
                                    Não foi possivel achar as informações!
                                </div>
                            </v-card>
                        </v-dialog>

                        <!-- modal Informações -->
                        <v-dialog v-model="dialog" persistent max-width="100%" content-class="box-dialog-inf">
                            <div class="container">
                                <v-btn color="blue darken-1" class="bot-exit" text @click="dialog = false">
                                    <v-img src="@/assets/iconexit.png" title="Sair" />
                                </v-btn>
                                <v-card>
                                    <div id="conteudoInfo">
                                        <div class="box-imagem">

                                            <img id="livroid" :src="informacoes.imagemCapa" />
                                            <a id="bot-livro" target="_blank">
                                                <v-btn large block tile depressed class="bot-livro" id="bot-livro"
                                                    @click="abrirFlipbook(informacoes.flipbookURL, informacoes.isbn, 0)">Visualizar
                                                    livro</v-btn>
                                            </a>
                                        </div>
                                        <div class="box-txt">
                                            <div class="infTitle">
                                                <v-img src="@/assets/icon-titulo.jpg" content-class="icon-tit" />
                                                <div id="InNome"> {{ informacoes.nomeTitulo }}</div>
                                            </div>

                                            <div class="infAtributos">
                                                <v-img src="@/assets/icon-atributos.jpg" />
                                                <div id="InAutor">Autor(es): {{ informacoes.autorNomeCapa }}</div>
                                            </div>
                                            <div class="infAtributos">
                                                <v-img src="@/assets/icon-atributos.jpg" />
                                                <div id="InSegmento">Segmento: {{ informacoes.segmento }}</div>
                                            </div>

                                            <div id="infDescricao">{{ informacoes.resumo }}</div>

                                            <div id="infISBN">
                                                <strong>ISBN: {{ informacoes.isbn }}</strong>
                                            </div>
                                            <div class="box-inf-detalhe">
                                                <div class="pag-de">
                                                    Páginas
                                                    <div id="infPagina">{{ informacoes.paginas }}</div>
                                                </div>
                                                <div class="pag-de">
                                                    Formato
                                                    <div id="infFormato">{{ informacoes.formato }}</div>
                                                </div>
                                                <div class="pag-de">
                                                    Ano
                                                    <div id="infAno">{{ informacoes.ano }}</div>
                                                </div>
                                                <div class="pag-de">
                                                    Disciplina
                                                    <div id="infDisciplina">{{ informacoes.disciplina }}</div>
                                                </div>
                                            </div>
                                            <div class="box-inf-detalhe" id="v-video">
                                                <div class="tiu-video">
                                                    Conheça
                                                </div>
                                                <a id="link-video" target="_blank">
                                                    <v-img src="@/assets/icon-video.jpg" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </v-card>
                            </div>
                        </v-dialog>
                    </v-container>
                    <!--
                    <v-row>
                        <v-container>
                            <div class="text-xs-center">
                                 <v-pagination v-model="page" :length="4" circle></v-pagination>
                            </div>
                        </v-container>
                    </v-row>
                -->
                </v-row>
            </v-container>
        </section>
        <a href="https://api.whatsapp.com/send?phone=5511972337522&text=Oi!" class="float" target="_blank" v-if="ebsa">
            <img src="../assets/whats.png" alt="Whatsapp" class="my-float img-responsive">
            <img src="../assets/Robo.svg" alt="Whatsapp" class="robo-aj">
        </a>
    </div>
</template>

<script src="https://cdnjs.cloudflare.com/ajax/libs/simplePagination.js/1.6/jquery.simplePagination.js"
    type="text/javascript"></script>

<script>
import $ from 'jquery';
import { VueAutosuggest } from "vue-autosuggest";
import { generateTokenAPI, http, baseURL } from "../services/APIservice";
import HeaderLogado from "./HeaderLogado";

//let UrlLogin = 'http://192.168.1.6:6158/api/User/Login';
//let UrlFlipbook = baseURL+'Flipbook/BuscarInformacoesFlipbook?Isbn=';

        // var loginVisu = {
        //     "type": "POST",
        //     "url": UrlLogin,
        //     "method": "POST",
        //     "timeout": 0,
        //     "headers": {
        //         "Content-Type": "application/json"
        //     },
        //     "data": JSON.stringify({
        //         "email": "wellington.zanelli@editoradobrasil2.com.br",
        //         "password": "e&D$$M02%@2025"
        //     }),
        // };

        // if (localStorage.getItem("token") === null) {   //Verifica se existe Token
        //     $.ajax(loginVisu).done(function (response) {
        //             localStorage.setItem("token", response.token);
        //     }).fail(function (response) {
        //             localStorage.removeItem("token");
        //     });
        // }


export default {
    name: "Catalogo",
    components: {
        VueAutosuggest,
        HeaderLogado
    },
    created() {
            try {
                const storage = JSON.parse(localStorage.getItem('user'));
                this.userName =  storage.userName.split(' ')[0];
                //this.Usuario = storage.usuario.nome
                //this.Guid = storage.usuario.guid
            }
            catch (error) {
            console.log(error);
            }
        },
    data() {
        this.getLocal();
        this.getLivros();

        return {
            dialogerror: false,
            dialog: false,
            userName: "",
            drawer: false,
            //filtros
            segmentos: [],
            segmentosAdicionados: [],
            anos: [],
            anosAdicionados: [],
            colecoes: [],
            colecoesAdicionadas: [],
            disciplinas: [],
            disciplinasAdicionadas: [],
            autores: [],
            autoresAdicionados: [],

            sheet: false, // Abre filtro no mobile
            page: 1, // paginação
            isActive: false, // Lazy content
            multiple: true, // Menu left
            flat: false,
            panel: [0, 1, 2, 3, 4, 5],
            right: null,
            cards: [],
            informacoes: {},
            query: "", // Busca
            selected: "",
            suggestions: [
                {
                    data: []
                }
            ],
            isMobile: false
        };
    },
    mounted() {
        // Verifica o tamanho da tela e ajusta o valor de isMobile
        this.isMobile = window.innerWidth <= 768;
        window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },
    watch: {
        selected: function (val) {
            if (val == "") {
                return;
            }
            this.abrirFlipbook(val.arquivo, val.id, val.complemento);
        }
    },
    computed: {
        filteredOptions() {
            return [
                {
                    data: this.suggestions[0].data.filter(option => {
                        return (
                            option.titulo.toLowerCase().indexOf(this.query.toLowerCase()) > -1
                        );
                    })
                }
            ];
        }
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        sair() {
            let self = this;
            localStorage.clear();
            self.$router.push('/');
        },
        getLocal() {
            try {
                const storage = JSON.parse(localStorage.getItem("user"));
                //this.Usuario = storage.usuario.nome
                //this.Guid = storage.usuario.guid
                this.ebsa = storage.ebsa;
                this.$parent.$root.$children[0].userName = storage.userName.split(
                    " "
                )[0];
                this.token = storage.token;
                this.livros = [];
            } catch (error) {
                //alert("Entre com seu usuário e senha para acessar o conteúdo.");
                let self = this;
                self.$router.push("/");
                console.log(error);
            }
        },
        async getLivros() {
            //const storage = JSON.parse(localStorage.getItem('user'));
            await http
                .get(`Flipbook/GetAll?userGuid=${this.token}`, {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + this.token
                    }
                })
                .then(res => {
                    //console.log(this.token);
                    this.livros = res.data;
                    this.livrosFilter = res.data;
                    this.setFiltros();
                    this.setLivros(this.livros);
                    this.setSuggestions();
                })
                .catch(err => {
                    console.log(err);
                    alert("Sua sessão expirou!");
                    this.$router.push("/");
                });
        },
        async setLogFlipbook(isbn, complemento) {
            http.put("Flipbook/LogAcessoFlipbook", { isbn: isbn, complemento: complemento }, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Authorization": "Bearer " + this.token
                }
            })

            return
        },
        // async verificarFlip(guid, token) {
        //     generateTokenAPI.get("GenerateGuid/Search?guid="+guid,
        //     {
        //         headers: {
        //             "Access-Control-Allow-Origin": "*",
        //             "Authorization": "Bearer " + token
        //         }
        //     })
        //     .then(res => {
        //         console.log(res.data.statusDescription);
        //     })
        //     .catch(err => {
        //         console.log(err);
        //         alert("Sua sessão expirou!");
        //         this.$router.push("/");
        //     });
        // },
        setSuggestions() {
            let suggestions = [];

            this.livros.forEach(function (livro) {
                suggestions.push({
                    id: livro.isbn,
                    titulo: livro.nome,
                    seguimento: livro.segmento,
                    imagem: livro.capaURL,
                    arquivo: livro.flipbookURL,
                    complemento: livro.complemento,
                });
            });

            this.suggestions[0].data = suggestions;
        },
        setLivros(livros) {
            let cards = [];
            livros.sort((a, b) => {
                return a.nome.localeCompare(b.nome);
            });

            livros.forEach(function (livro) {
                cards.push({
                    isbn: livro.isbn,
                    title: livro.nome,
                    src: livro.capaURL,
                    flex: 3,
                    arquivo: livro.flipbookURL,
                    autor: livro.autor,
                    complemento: livro.complemento
                });
            });

            this.cards = cards;
        },
        setFiltros() {
            let filtros = {
                autores: [],
                segmentos: [],
                disciplinas: [],
                anos: [],
                colecoes: []
            };
            this.livros.forEach(function (livro) {
                if (!filtros.autores.includes(livro.autor)) {
                    filtros.autores.push(livro.autor);
                }
                if (!filtros.segmentos.includes(livro.segmento)) {
                    filtros.segmentos.push(livro.segmento);
                }
                if (!filtros.disciplinas.includes(livro.materia)) {
                    filtros.disciplinas.push(livro.materia);
                }
                if (!filtros.anos.includes(livro.ano)) {
                    filtros.anos.push(livro.ano);
                }
                if (!filtros.colecoes.includes(livro.colecao)) {
                    filtros.colecoes.push(livro.colecao);
                }
            });

            this.anos = filtros.anos.sort();
            this.autores = filtros.autores.sort();
            this.colecoes = filtros.colecoes.sort();
            this.disciplinas = filtros.disciplinas.sort();
            this.segmentos = filtros.segmentos.sort();
            //this.filtros = filtros;
        },
//         async abrirFlipbook(url, isbn, complemento) {
//     // Precisa acontecer imediatamente no clique
//     const janelaFlipbook = window.open("about:blank", "_blank");

//     if (janelaFlipbook) {
//         try {
//             janelaFlipbook.document.write(`
//                 <html>
//                     <head>
//                         <title>Carregando...</title>
//                     </head>
//                     <body style="font-family: Arial, sans-serif;">
//                         <p></p>
//                     </body>
//                 </html>
//             `);
//             janelaFlipbook.document.close();
//         } catch (e) {
//         }
//     }

//     try {
//         const storageGT = JSON.parse(localStorage.getItem("GT"));

//         if (!storageGT || !storageGT.token || storageGT.user_id == null) {
//             if (janelaFlipbook && !janelaFlipbook.closed) {
//                 janelaFlipbook.close();
//             }

//             alert("Sua sessão expirou!");
//             this.$router.push("/");
//             return;
//         }

//         this.gtToken = storageGT.token;
//         this.gtCodUser = storageGT.user_id;

//         const res = await generateTokenAPI.post(
//             "GenerateGuid/Create",
//             { user_Id: this.gtCodUser },
//             {
//                 headers: {
//                     Authorization: "Bearer " + this.gtToken
//                 }
//             }
//         );

//         // Monta a URL final diretamente
//         const urlFinal = new URL(url);
//         urlFinal.searchParams.set("guid", res.data.guid);
//         urlFinal.searchParams.set("token", this.gtToken);

//         if (janelaFlipbook && !janelaFlipbook.closed) {
//             try {
//                 janelaFlipbook.opener = null;
//             } catch (e) {}

//             // Abre diretamente o flipbook, sem passar pelo Vue Router
//             janelaFlipbook.location.replace(urlFinal.toString());
//         } else {
//             // Fallback caso o navegador bloqueie a nova janela
//             window.location.href = urlFinal.toString();
//         }

//         this.setLogFlipbook(isbn, complemento);
//     } catch (err) {
//         console.log(err);

//         if (janelaFlipbook && !janelaFlipbook.closed) {
//             janelaFlipbook.close();
//         }

//         alert("Sua sessão expirou!");
//         this.$router.push("/");
//     }
// },
    // async abrirFlipbook(url, isbn, complemento) {
    //             // Precisa acontecer imediatamente no clique
    //             const janelaFlipbook = window.open("about:blank", "_blank");

    //             if (janelaFlipbook) {
    //                 try {
    //                     janelaFlipbook.document.write(`
    //                         <html>
    //                             <head>
    //                                 <title>Carregando...</title>
    //                             </head>
    //                             <body style="font-family: Arial, sans-serif;">
    //                                 <p>Carregando livro...</p>
    //                             </body>
    //                         </html>
    //                     `);
    //                     janelaFlipbook.document.close();
    //                 } catch (e) {
    //                     // Alguns navegadores podem restringir escrita no popup.
    //                     // Não precisa interromper o fluxo por isso.
    //                 }
    //             }

    //             try {
    //                 const storageGT = JSON.parse(localStorage.getItem("GT"));

    //                 if (!storageGT || !storageGT.token || storageGT.user_id == null) {
    //                     if (janelaFlipbook && !janelaFlipbook.closed) {
    //                         janelaFlipbook.close();
    //                     }

    //                     alert("Sua sessão expirou!");
    //                     this.$router.push("/");
    //                     return;
    //                 }

    //                 this.gtToken = storageGT.token;
    //                 this.gtCodUser = storageGT.user_id;

    //                 const res = await generateTokenAPI.post(
    //                     "GenerateGuid/Create",
    //                     { user_Id: this.gtCodUser },
    //                     {
    //                         headers: {
    //                             Authorization: "Bearer " + this.gtToken
    //                         }
    //                     }
    //                 );

    //                 const params = `?guid=${res.data.guid}&token=${this.gtToken}`;

    //                 const routeData = this.$router.resolve({
    //                     name: "flippingbook",
    //                     query: {
    //                         id: url + params
    //                     }
    //                 });

    //                 if (janelaFlipbook && !janelaFlipbook.closed) {
    //                     try {
    //                         janelaFlipbook.opener = null;
    //                     } catch (e) {}

    //                     janelaFlipbook.location.href = routeData.href;
    //                 } else {
    //                     // Fallback caso o navegador bloqueie mesmo assim.
    //                     // Pode ser trocar por exibir um link manual, se preferir.
    //                     window.location.href = routeData.href;
    //                 }

    //                 this.setLogFlipbook(isbn, complemento);
    //             } catch (err) {
    //                 console.log(err);

    //                 if (janelaFlipbook && !janelaFlipbook.closed) {
    //                     janelaFlipbook.close();
    //                 }

    //                 alert("Sua sessão expirou!");
    //                 this.$router.push("/");
    //             }
    //         },
//     async abrirFlipbook(url, isbn, complemento) {
//     // Precisa acontecer imediatamente no clique para evitar bloqueio de popup,
//     // principalmente em Safari/iOS.
//     const janelaFlipbook = window.open("about:blank", "_blank");

//     if (janelaFlipbook) {
//         try {
//             janelaFlipbook.document.write(`
//                 <html>
//                     <head>
//                         <title>Carregando...</title>
//                     </head>
//                     <body style="font-family: Arial, sans-serif;">
//                         <p>Carregando livro...</p>
//                     </body>
//                 </html>
//             `);
//             janelaFlipbook.document.close();
//         } catch (e) {
//             // Alguns navegadores podem restringir escrita no popup.
//             // Não precisa interromper o fluxo por isso.
//         }
//     }

//     try {
//         const storageGT = JSON.parse(localStorage.getItem("GT"));

//         if (!storageGT || !storageGT.token || storageGT.user_id == null) {
//             if (janelaFlipbook && !janelaFlipbook.closed) {
//                 janelaFlipbook.close();
//             }

//             alert("Sua sessão expirou!");
//             this.$router.push("/");
//             return;
//         }

//         this.gtToken = storageGT.token;
//         this.gtCodUser = storageGT.user_id;

//         const res = await generateTokenAPI.post(
//             "GenerateGuid/Create",
//             {
//                 user_Id: this.gtCodUser
//             },
//             {
//                 headers: {
//                     Authorization: "Bearer " + this.gtToken
//                 }
//             }
//         );

//         // Monta a URL final diretamente no domínio dos conteúdos.
//         // Exemplo:
//         // https://conteudos.editoradobrasil.com.br/flipbook/...?...guid=...&token=...
//         const urlFlipbook = new URL(url);

//         urlFlipbook.searchParams.set("guid", res.data.guid);
//         urlFlipbook.searchParams.set("token", this.gtToken);

//         const destino = urlFlipbook.href;

//         if (janelaFlipbook && !janelaFlipbook.closed) {
//             try {
//                 janelaFlipbook.opener = null;
//             } catch (e) {
//                 // Ignora caso o navegador bloqueie alteração do opener.
//             }

//             janelaFlipbook.location.replace(destino);
//         } else {
//             // Fallback caso o navegador bloqueie a nova aba.
//             window.location.href = destino;
//         }

//         this.setLogFlipbook(isbn, complemento);
//     } catch (err) {
//         console.log(err);

//         if (janelaFlipbook && !janelaFlipbook.closed) {
//             janelaFlipbook.close();
//         }

//         alert("Sua sessão expirou!");
//         this.$router.push("/");
//     }
// },
async abrirFlipbook(url, isbn, complemento) {
    const janelaFlipbook = window.open("about:blank", "_blank");

    if (janelaFlipbook) {
        try {
            janelaFlipbook.document.write(`
                <html>
                    <head>
                        <title>Carregando...</title>
                    </head>
                    <body style="font-family: Arial, sans-serif;">
                        <p></p>
                    </body>
                </html>
            `);
            janelaFlipbook.document.close();
        } catch (e) {}
    }

    try {
        const storageGT = JSON.parse(localStorage.getItem("GT"));

        if (!storageGT || !storageGT.token || storageGT.user_id == null) {
            if (janelaFlipbook && !janelaFlipbook.closed) {
                janelaFlipbook.close();
            }

            alert("Sua sessão expirou!");
            this.$router.push("/");
            return;
        }

        this.gtToken = storageGT.token;
        this.gtCodUser = storageGT.user_id;

        const res = await generateTokenAPI.post(
            "GenerateGuid/Create",
            {
                user_Id: this.gtCodUser
            },
            {
                headers: {
                    Authorization: "Bearer " + this.gtToken
                }
            }
        );

        const params = `?guid=${res.data.guid}&token=${this.gtToken}`;

        const routeData = this.$router.resolve({
            name: "flippingbook",
            query: {
                id: url + params
            }
        });

        const destino = new URL(routeData.href, window.location.origin).href;

        if (janelaFlipbook && !janelaFlipbook.closed) {
            janelaFlipbook.location.href = destino;
        } else {
            window.location.href = destino;
        }

        this.setLogFlipbook(isbn, complemento);
    } catch (err) {
        console.log(err);

        if (janelaFlipbook && !janelaFlipbook.closed) {
            janelaFlipbook.close();
        }

        alert("Sua sessão expirou!");
        this.$router.push("/");
    }
},
        async Visualizacao(url, id, complemento){
            $("#v-video").fadeOut();
            //$("#livroid").fadeOut();

            http.post('Flipbook/BuscarInformacoesFlipbook?Isbn='+id+ '&complemento=' +complemento, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Authorization": "Bearer " + this.token
                }
            }).then(res => {
                //console.log(res);
                this.informacoes = res.data;
                //console.log(this.informacoes);

                $("#livroid").attr('src', res.data.imagemCapa);
                $("#InNome").html(res.data.nomeTitulo);
                $("#infISBN").html('<strong>ISBN: </strong>'+res.data.isbn);
                $("#infDescricao").html(res.data.resumo);
                $("#infPagina").html(res.data.paginas);
                $("#infFormato").html(res.data.formato);
                $("#infAno").html(res.data.ano);
                $("#InAutor").html('Autor(es): '+res.data.autorNomeCapa);
                $("#InSegmento").html('Segmento: '+res.data.segmento);
                $("#infDisciplina").html(res.data.disciplina);
                //$("#bot-livro").attr('href',res.data.flipbookURL);


                if(res.data.link !='Sem vídeo'){
                    if(res.data.link !=''){
                        //console.log('entrou no primeiro');
                        if (res.data.link.indexOf('watch') > -1)
                        {
                            //console.log('entrou 2');
                            var codV = res.data.link.split('watch?v=');
                            if (res.data.link.indexOf('&') > -1)
                            {
                                codV = codV[1].split('&');
                                codV = codV[0];
                            }else{
                                codV = codV[1];
                            }
                            //console.log(codV);
                        }else{
                            //console.log('entrou 3');
                            var codV = res.data.link.split('https://youtu.be/');
                            codV = codV[1];
                        }
                        var AuxV = '<iframe width="100%" height="315" src="https://www.youtube.com/embed/'+codV+'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>';
                        console.log(AuxV);
                        $("#link-video").html(AuxV);
                        $("#v-video").fadeIn();
                    }else{
                        $("#v-video").fadeOut();
                    }
                }else{
                    $("#v-video").fadeOut();
                }
                //$("#livroid").fadeIn();
                localStorage.setItem("aux", 1);

                if(res.data.isbn == null){
                    this.dialog=false;
                    this.dialogerror = true;
                }else{
                    this.dialog=true;
                    this.dialogerror = false;
                }
            }).catch(err => {
                console.log(err);
                alert("Sua sessão expirou!");
                this.$router.push("/");
            });


            // var FlipResult2 = {
            //     "url": UrlFlipbook+id,
            //     "method": "POST",
            //     "timeout": 0,
            //     "headers": {
            //         "Authorization": "Bearer "+localStorage.getItem("token")
            //     },
            // };

            // $.ajax(FlipResult2).done(function (response) {
            //     this.informacoes = {
            //         arquivo: response.flipbookURL,
            //         id: response.isbn,
            //         complemento: 0
            //     };
            //     //this.informacoes = response;
            //     this.isbn =response.isbn;
            //     this.nome = response.nomeTitulo;
            //     this.autor = response.autorNomeCapa;
            //     this.resumo = response.resumo;
            //     this.imagemCapa = response.imagemCapa;
            //     this.segmento = response.isegmento;
            //     this.disciplina = response.disciplina;
            //     this.ano = response.ano;
            //     this.paginas = response.paginas;
            //     this.formato = response.formato;
            //     this.link = response.link;
            //     //$("#livroid").attr('src','https://'+response.imagemCapa);
            //     console.log(this.informacoes);

            //     $("#livroid").attr('src',response.imagemCapa);
            //     $("#InNome").html(response.nomeTitulo);
            //     $("#infISBN").html('<strong>ISBN: </strong>'+response.isbn);
            //     $("#infDescricao").html(response.resumo);
            //     $("#infPagina").html(response.paginas);
            //     $("#infFormato").html(response.formato);
            //     $("#infAno").html(response.ano);
            //     $("#InAutor").html('Autor(es): '+response.autorNomeCapa);
            //     $("#InSegmento").html('Segmento: '+response.segmento);
            //     $("#infDisciplina").html(response.disciplina);
            //     //$("#bot-livro").attr('href',response.flipbookURL);


            //     if(response.link !='Sem vídeo'){
            //         if(response.link !=''){
            //             console.log('entrou no primeiro');
            //             if (response.link.indexOf('watch') > -1)
            //             {
            //                 console.log('entrou 2');
            //                 var codV = response.link.split('watch?v=');
            //                 if (response.link.indexOf('&') > -1)
            //                 {
            //                     codV = codV[1].split('&');
            //                     codV = codV[0];
            //                 }else{
            //                     codV = codV[1];
            //                 }
            //                 console.log(codV);
            //             }else{
            //                 console.log('entrou 3');
            //                 var codV = response.link.split('https://youtu.be/');
            //                 codV = codV[1];
            //             }
            //             var AuxV = '<iframe width="100%" height="315" src="https://www.youtube.com/embed/'+codV+'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>';
            //             console.log(AuxV);
            //             $("#link-video").html(AuxV);
            //             $("#v-video").fadeIn();
            //         }else{
            //             $("#v-video").fadeOut();
            //         }
            //     }else{
            //         $("#v-video").fadeOut();
            //     }
            //     //$("#livroid").fadeIn();
            //     localStorage.setItem("aux", 1);

            //     if(response.isbn == null){
            //         this.dialog=false;
            //         this.dialogerror = true;
            //     }else{
            //         this.dialog=true;
            //         this.dialogerror = false;
            //     }

            // }).fail(function (response) {
            //     console.log(response);
            //     this.dialogerror = true;
            //     localStorage.setItem("aux", 0);
            // });

            if(localStorage.getItem("aux") == 1){
                this.dialog=true;
                this.dialogerror = false;
            } else{
                this.dialog=false;
                this.dialogerror = true;
            }
        },
        setFilter(isbn, complemento) {
            let livro = this.livros.filter(livro => livro.isbn == isbn && livro.complemento == complemento);
            this.setLivros(livro);
        },
        filterSegmento(value) {
            if (this.segmentosAdicionados.includes(value)) {
                this.segmentosAdicionados.splice(
                    this.segmentosAdicionados.indexOf(value),
                    1
                );
                this.filterMaster();
                return;
            }
            this.segmentosAdicionados.push(value);
            this.filterMaster();
        },
        filterAno(value) {
            if (this.anosAdicionados.includes(value)) {
                this.anosAdicionados.splice(this.anosAdicionados.indexOf(value), 1);
                this.filterMaster();
                return;
            }
            this.anosAdicionados.push(value);

            this.filterMaster();
        },
        filterDisciplina(value) {
            if (this.disciplinasAdicionadas.includes(value)) {
                this.disciplinasAdicionadas.splice(
                    this.disciplinasAdicionadas.indexOf(value),
                    1
                );
                this.filterMaster();
                return;
            }
            this.disciplinasAdicionadas.push(value);

            this.filterMaster();
        },
        filterColecao(value) {
            if (this.colecoesAdicionadas.includes(value)) {
                this.colecoesAdicionadas.splice(
                    this.colecoesAdicionadas.indexOf(value),
                    1
                );
                this.filterMaster();
                return;
            }
            this.colecoesAdicionadas.push(value);
            this.filterMaster();
        },
        filterAutor(value) {
            if (this.autoresAdicionados.includes(value)) {
                this.autoresAdicionados.splice(
                    this.autoresAdicionados.indexOf(value),
                    1
                );
                this.filterMaster();
                return;
            }
            this.autoresAdicionados.push(value);
            this.filterMaster();
        },
        filterMaster() {
            let livros = this.livros;
            if (this.disciplinasAdicionadas.length > 0) {
                livros = livros.filter(livro =>
                    this.disciplinasAdicionadas.includes(livro.materia)
                );
            }
            if (this.anosAdicionados.length > 0) {
                livros = livros.filter(livro =>
                    this.anosAdicionados.includes(livro.ano)
                );
            }
            if (this.segmentosAdicionados.length > 0) {
                livros = livros.filter(livro =>
                    this.segmentosAdicionados.includes(livro.segmento)
                );
            }
            if (this.colecoesAdicionadas.length > 0) {
                livros = livros.filter(livro =>
                    this.colecoesAdicionadas.includes(livro.colecao)
                );
            }
            if (this.autoresAdicionados.length > 0) {
                livros = livros.filter(livro =>
                    this.autoresAdicionados.includes(livro.autor)
                );
            }


            //if(livros.length == 0){ alert('Infelizmente não existe um livro com base nos filtros selecionados')}

            this.setLivros(livros);
        },
        pesquisarNome() {
            let value = this.query;
            let livros = this.livros.filter(function (livro) {
                return livro.nome.toUpperCase().includes(value.toUpperCase());
            });
            this.setLivros(livros);
        },
        limparFiltros() {
            this.setFilter();
        },
        onSelected(item) {
            this.selected = item.item;
        },
        onInputChange() {
            // event fired when the input changes
        },
        /**
         * This is what the <input/> value is set to when you are selecting a suggestion.
         */
        getSuggestionValue(suggestion) {

            return suggestion.item.name;
        },
        focusMe() {
            // FocusEvent
        }
    }
    // created() {
    //     this.getStorageGT()
    // }
};

</script>

<style lang="scss">
@use "../css/style.scss";

section.banner-catalogo {
    background-image: url("../assets/bg-catalogo.png");
    /* Full height */
    height: 100vh;
    max-height: 486px;
    //height: 100%;
    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    @media only screen and (max-width: 600px) {
        max-height: 286px;
    }
}

.catalogo-title {
    margin-top: 140px;
    max-width: 470px;
}

.parte {
    background: rgba(25, 40, 110, 0.7) !important;
    color: white !important;
    width: auto !important;
    display: initial !important;
    margin-top: 24px;
    font-size: 48px;
    font-weight: bolder;
}

.busca {
    background: #19286e;

    @media only screen and (max-width: 959.99px) {
        margin: 104px 0 0 0;
        background: none !important;
    }

    .campo-de-busca {
        background: white;
        width: 100%;
        max-width: 500px;
        margin: 0 24px;

        @media only screen and (max-width: 959.99px) {
            max-width: auto;
            margin: 0;
            border: 1px solid #19286e;
        }
    }

    input {
        width: 100%;
        padding: 0.5rem;
        border: 0 !important;
    }

    ul {
        width: 100%;
        color: rgba(30, 39, 46, 1);
        list-style: none;
        margin: 0;
        padding: 0.5rem 0 0.5rem 0;
    }

    li {
        margin: 0 0 0 0;
        padding: 0.75rem 0 0.75rem 0.75rem;
        display: flex;
        align-items: center;
    }

    li:hover {
        cursor: pointer;
    }

    .autosuggest-container {
        display: flex;
        justify-content: center;
    }

    :focus {
        outline: -webkit-focus-ring-color auto 0 !important;
        //remove borda do input qdo tem focus
    }

    #autosuggest {
        width: 100%;
        display: block;
    }

    .autosuggest__results-item--highlighted {
        background-color: #efefef;
    }

    .autosuggest__results-container {
        background: white;
        width: 100%;
        max-width: 500px;
        max-height: 400px;
        overflow-x: auto;
        position: absolute;
        z-index: 9;
        -webkit-box-shadow: 0px 3px 5px 0px rgba(105, 21, 21, 0.3);
        -moz-box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);
        box-shadow: 0px 3px 5px 0px rgba(3, 2, 2, 0.3);
    }
}

.filtro {
    &.v-card {
        border-radius: 0;
    }

    .title {
        background: #eee;
    }

    .v-list-item__title {
        padding: 8px 16px;
        color: #19286e;
    }

    .v-expansion-panel::before {
        box-shadow: none;
    }

    .v-expansion-panel-header {
        min-height: initial;
        padding: 16px;
        color: #19286e;
    }

    .v-list-item {
        padding: 0;
    }

    .v-input--selection-controls {
        margin-top: 0;
        padding-top: 4px;
    }

    .v-label {
        font-size: 13px;
    }

    .v-messages {
        display: none;
    }

    &.filtro-mobile {
        height: 95vh;

        .v-item-group {
            overflow-x: auto !important;
            height: calc(95vh - 76px);
            padding-bottom: 16px;
        }
    }
}

.btn-filtrar {

    &.v-btn,
    .v-icon {
        color: #19286e;
    }
}

.btn-fechar-filtro {
    position: absolute;
    top: 12px;
    right: 16px;
}

.grid {

    &>.col,
    &>[class*="col-"] {
        padding: 0 !important;
    }

    .flex {
        padding: 0 0 16px 0 !important;
    }

    .v-image__image--cover {
        background-size: contain;
    }

    a {
        text-decoration: none;
    }

    .v-card {
        border-radius: 0;

        .v-card__title {
            color: #19286e;
            align-items: left;
            font-size: 1rem;
            font-weight: 600;
            letter-spacing: 0.0125em;
            line-height: 1.2rem;
            padding: 8px 16px 8px 16px;
            word-break: initial;
        }

        .v-card__actions {
            width: 100%;
            padding: 0;
            position: absolute;
            bottom: 0;
        }

        .v-btn {
            background-color: #93c83d !important;
            color: #19286e;
        }

        &.elevation-2 {
            box-shadow: none !important;
        }
    }

    .v-pagination__item,
    .v-pagination__navigation {
        box-shadow: none;
    }

    .v-pagination__item:focus,
    .v-pagination__navigation:focus {
        outline: -webkit-focus-ring-color auto 0;
    }

    .layout:only-child {
        margin: 0 !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
}

.float {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 40px;
    right: 20px;
    background-color: #25d366;
    color: #FFF;
    border-radius: 50px;
    text-align: center;
    font-size: 30px;
    //box-shadow: 2px 2px 3px #999;
    z-index: 100;
}

.my-float {
    width: 100%;
}
</style>
